exports = module.exports = require("../../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Applies styles for users in high contrast mode. Note that this only applies\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n * attribute, however Chrome handles high contrast differently.\n */\n/* Theme for the ripple elements.*/\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n.avatar {\n  width: 100px;\n  min-width: 100px;\n  height: 100px;\n  line-height: 100px;\n  margin: 0 8px 0 0;\n  border-radius: 50%;\n  font-size: 17px;\n  font-weight: 500;\n  text-align: center;\n  color: #FFFFFF; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/basic-info/basicInfo.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/basic-info/basicInfo.component.scss
// module chunks = main